export const SharedConsts = {
    CONFIG_API_URL: 'web/v3/app/retailer-config-helper/',
    NO_LOADER: 'no-loader',
    NUMBER_PATTERN: /^-?\d+$/,
    NUMERIC:/^[0-9]*$/,
    EMAIL_PATTERN: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    PASSWORD_PATTERN: /^(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,15}$/,
    URL_PATTERN: /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)(?:\.(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)*(?:\.(?:[a-zA-Z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/,
    ALPHA_NUMERIC: /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d][A-Za-z\d!@#$%^&*()_+]{5,14}$/,
    GOOGLEANALYTICSS_EVENT_CATEGORY_NAME:'world of sweets',
    GOOGLEANALYTICSS_EVENT_LABEL:'click',
    GOOGLEANALYTICSS_EVENT_VALUE:10,

    BASKET_BACK_BUTTON_EVENT:"basket_back_button_press",
    BASKET_BACK_BUTTON_EVENT_ACTION:"basket back button press",
    MYCART_PROMOTION_CLICK_EVENT:'mycart_promotion_click',
    MYCART_PROMOTION_CLICK_EVENT_ACTION:'promotion click on mycart page',
    PLACE_ORDER_EVENT:"place_order",
    PLACE_ORDER_EVENT_ACTION:"place order",

    MYCART_BACKINSTOCK_ADDTOCART_EVENT:"mycart_backinstock_addToCart",
    MYCART_BACKINSTOCK_ADDTOCART_EVENT_ACTION:"back in stock section add to cart",

    BASKET_REMOVE_ALL_EVENT:"basket_remove_all",
    BASKET_REMOVE_ALL_EVENT_ACTION:"remove cart item",
    BASKET_REMOVE_CART_ITEM_EVENT:"basket_remove_cart_item",
    BASKET_REVIEW_CLICK_EVENT:'basket_review_click',
    BASKET_REVIEW_CLICK_EVENT_ACTION:'basket review click',

    ORDER_SUMMARY_PROMOTION_CLICK_EVENT:"order_summary_promotion_click",
    ORDER_SUMMARY_PROMOTION_CLICK_EVENT_ACTION:'promotion click on order summary page',

    REVIEW_ADD_PRODUCT_CLICK_EVENT:"review_add_product_click",
    REVIEW_ADD_PRODUCT_CLICK_EVENT_ACTION:"review add product click",
    REVIEW_ORDER_SUMMARY_CLICK_EVENT:"review_order_summary_click",
    REVIEW_ORDER_SUMMARY_CLICK_EVENT_ACTION:"review order summary click",

    HOME_ALL_MENU_SELECTED_EVENT:'home_all_menu_selected',
    HOME_ALL_MENU_SELECTED_EVENT_ACTION:'home all menu selected',
    HOME_MYORDER_MENU_SELECTED_EVENT:'home_myorder_menu_selected',
    HOME_MYORDER_MENU_SELECTED_EVENT_ACTION:'home myorder menu selected',
    HOME_CATEGORY_MENU_SELECTED_EVENT:'home_category_menu_selected',
    HOME_CATEGORY_MENU_SELECTED_EVENT_ACTION:'home category menu selected',
    HOME_NEW_MENU_SELECTED_EVENT:'home_new_menu_selected',
    HOME_NEW_MENU_SELECTED_EVENT_ACTION:'home new  menu selected',
    HOME_PROMOTION_MENU_SELECTED_EVENT:'home_promotions_menu_selected',
    HOME_PROMOTION_MENU_SELECTED_EVENT_ACTION:'home promotions menu selected',
    HOME_BRAND_MENU_SELECTED_EVENT:'home_brand_menu_selected',
    HOME_BRAND_MENU_SELECTED_EVENT_ACTION:'home brand menu selected',
    HOME_IOS_APP_DOWNLOAD_EVENT:"home_ios_app_download",
    HOME_IOS_APP_DOWNLOAD_EVENT_ACTION:"home ios app download",
    HOME_ANDRIOD_APP_DOWNLOAD_EVENT:"home_andriod_app_download",
    HOME_ANDRIOD_APP_DOWNLOAD_EVENT_ACTION:"home andriod app download",
    HOME_BRAND_FILTER_APPLIED_EVENT:"home_brand_filter_applied",
    HOME_BRAND_FILTER_APPLIED_EVENT_ACTION:"home brand filter applied",
    HOME_BANNER_SELECTED_EVENT:"home_banner_selected",
    HOME_BANNER_SELECTED_EVENT_ACTION:"home banner selected",
    HOME_PROMOTIONS_VIEW_ALL_EVENT:'home_promotions_view_all',
    HOME_PROMOTIONS_VIEW_ALL_EVENT_ACTION:'Home page promotion view all',
    HOME_PROMOTIONS_VIEW_ALL_PRODUCTS_EVENT:'home_promotion_all_products',
    HOME_PROMOTIONS_VIEW_ALL__PRODUCTS_EVENT_ACTION:'Home page promotion view products',
    HOME_PROMOTION_ADD_DEAL_EVENT:"home_promotion_add_deal",
    HOME_PROMOTION_ADD_DEAL_EVENT_ACTION:"Home page promotion add deal",
    HOME_PRODUCT_DETAIL_NEWIN_EVENT:'home_product_detail_newin',
    HOME_PRODUCT_DETAIL_NEWIN_EVENT_ACTION:'new section redirect to product detail',
    HOME_ADDTOCART_NEWIN_EVENT:'home_addtocart_newin',
    HOME_ADDTOCART_NEWIN_EVENT_ACTION:'home addtocart newin',
    HOME_NEWIN_VIEW_ALL_EVENT:"home_newin_view_all",
    HOME_NEWIN_VIEW_ALL_EVENT_ACTION:"home newin view all",
    HOME_PROMOTION_REMOVE_DEAL_EVENT:"home_promotion_remove_deal",
    HOME_PROMOTION_REMOVE_DEAL_EVENT_ACTION:"Home page promotion remove deal",

    PRODCAT_TOP_SELLER_FILTER_APPLIED_EVENT:'prodcat_top_seller_filter_applied',
    PRODCAT_TOP_SELLER_FILTER_APPLIED_EVENT_ACTION:'Top seller filter applied on product listing',
    PRODCAT_MY_RANGE_FILTER_APPLIED_EVENT:'prodcat_my_range_filter_applied',
    PRODCAT_MY_RANGE_FILTER_APPLIED_EVENT_ACTION:'My range filter applied on product listing',
    PRODCAT_PMP_PRODUCTS_FILTER_APPLIED_EVENT:'prodcat_pmp_products_filter_applied',
    PRODCAT_PMP_PRODUCTS_FILTER_APPLIED_EVENT_ACTION:'Pmp products filter applied on product listing',
    PRODCAT_BRAND_FILTER_APPLIED_EVENT:'prodcat_brand_filter_applied',
    PRODCAT_BRAND_FILTER_APPLIED_EVENT_ACTION:'Brand filter applied on product listing',
    PRODCAT_PROMOTION_FILTER_APPLIED_EVENT:'prodcat_promotion_filter_applied',
    PRODCAT_PROMOTION_FILTER_APPLIED_EVENT_ACTION:'Promotion filter applied on product listing',
    PRODCAT_VIEW_PRODUCT_DETAILS_PLP_EVENT:'prodcat_view_product_details_plp',
    PRODCAT_VIEW_PRODUCT_DETAILS_PLP_EVENT_ACTION:'prodCat view product details plp',
    PRODCAT_RSP_FILTER_APPLIED_EVENT:'prodcat_rsp_filter_applied',
    PRODCAT_RSP_FILTER_APPLIED_EVENT_ACTION:'Rsp filter applied on product listing',
    PRODCAT_SEARCH_RESULT_NOT_FOUND_EVENT:'prodcat_search_result_not_found',
    PRODCAT_SEARCH_RESULT_NOT_FOUND_EVENT_ACTION:'search result not found',
    PRODCAT_SEARCH_RESULT_FOUND_PLP_EVENT:'prodcat_search_result_found_plp',
    PRODCAT_SEARCH_RESULT_FOUND_PLP_EVENT_ACTION:'search result found',
    PRODCAT_SEARCH_RESULT_NOT_FOUND_PLP_EVENT:'prodcat_search_result_not_found_plp',
    PRODCAT_ADDTOCART_PLP_EVENT:'prodcat_addtocart_plp',
    PRODCAT_ADDTOCART_PLP_EVENT_ACTION:'Product Listing section add to cart',
    PRODCAT_ADDTOCART_PDP_EVENT:'prodcat_addtocart_pdp',
    PRODCAT_ADDTOCART_PDP_EVENT_ACTION:'Product Detail section add to cart',

    PROMOTION_VIEW_PRODUCTS_EVENT:'promotion_view_products',
    PROMOTION_VIEW_PRODUCTS_EVENT_ACTION:'Promotion view products',
    PROMOTION_ADD_DEAL_EVENT:'promotion_add_deal',
    PROMOTION_ADD_DEAL_EVENT_ACTION:'promotion add deal',
    PROMOTION_REMOVE_DEAL_EVENT:'promotion_remove_deal',
    PROMOTION_REMOVE_DEAL_EVENT_ACTION:'promotion remove deal',

    PROMOTION_PRODUCT_LISTING_ADDTOCART_EVENT:'promotion_addtocart_promotion_details',
    PROMOTION_PRODUCT_LISTING_ADDTOCART_EVENT_ACTION:'promotion product to add to cart',
    PROMOTION_ADD_DEAL_PROMOTION_DETAILS_EVENT:'promotion_add_deal_promotion_details',
    PROMOTION_ADD_DEAL_PROMOTION_DETAILS_EVENT_ACTION:'promotion add deal promotion deal',
    PROMOTION_REMOVE_DEAL_PROMOTION_DETAILS_EVENT:'promotion_remove_deal_promotion_details',
    PROMOTION_REMOVE_DEAL_PROMOTION_DETAILS_EVENT_ACTION:'promotion remove deal promotion deal',
    ERROR_BRAND_NOT_SELECTED:'Please select atleast one brand',

    VIEW_BASKET_EVENT:'view_basket',
    VIEW_BASKET_EVENT_ACTION:'view basket',

    QUICKADD_ADDTOCART_EVENT:'quickadd_addToCart',
    QUICKADD_ADDTOCART_EVENT_ACTION:'Quick add section add to cart',

    STORE_CHANGE_EVENT:'store_change',
    STORE_CHANGE_EVENT_ACTION:'store change',

    FORGOT_PASSWORD_EVENT:'forgot_password',
    FORGOT_PASSWORD_EVENT_ACTION:'forgot password',

    SIGNIN_FAILS_EVENT:'signin_fails',
    SIGNIN_FAILS_EVENT_ACTION:'signin fails',

    SIGNIN_EVENT:'signin',
    SIGNIN_EVENT_ACTION:'signin',

    SIGNUP_EVENT:'signup',
    SIGNUP_EVENT_ACTION:'signup',

    HOST_ALLOWED:['203.100.67.242' ,'125.16.65.194', '188.65.99.228', '122.173.26.181'],

    SERVER_ALLOWED:['production']

    

    
};